export default {
    accountList: {
        method: "POST",
        url: "/adminScreen/screen-user/user-list",
        name: "账号列表"
    },
    accountAdd: {
        method: "POST",
        url: "/adminScreen/screen-user/add-user",
        name: "新增账号"
    },
    accountInfo: {
        method: "POST",
        url: "/adminScreen/screen-user/user-info",
        name: "账号详情"
    },
    accountSave: {
        method: "POST",
        url: "/adminScreen/screen-user/user-save",
        name: "账号编辑"
    },
    accountSet: {
        method: "POST",
        url: "/adminScreen/screen-user/user-set",
        name: "账号启用禁用"
    },
};